"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendMailActionPicker = void 0;
const lib_event_1 = __importDefault(require("@opsbase/lib-event"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const WorkflowAction_1 = __importDefault(require("@opsbase/lib-workflow/WorkflowAction"));
const react_markdown_1 = require("@opsbase/react-markdown");
const react_simple_quill_1 = __importDefault(require("@opsbase/react-simple-quill"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const TextFieldWithEmails_1 = __importDefault(require("@opsbase/web-textfield/TextFieldWithEmails/TextFieldWithEmails"));
const TextFieldWithStateAndBlur_1 = __importDefault(require("@opsbase/web-textfield/TextFieldWithStateAndBlur/TextFieldWithStateAndBlur"));
const Checkbox_1 = __importDefault(require("@opsbase/web-ui/Checkbox/Checkbox"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const Radio_1 = __importDefault(require("@opsbase/web-ui/Radio/Radio"));
const RadioGroup_1 = __importDefault(require("@opsbase/web-ui/RadioGroup/RadioGroup"));
const makeMyClasses = () => ({
    root: {
        '& em': {
            fontStyle: 'italic !important',
            color: 'black !important',
        },
        '& strong': {
            fontStyle: 'normal',
            fontWeight: 'bold',
        },
        '& .ql-toolbar.ql-snow': {
            borderColor: lib_palette_1.default.BorderGrey.main,
        },
        '& .ql-snow .ql-tooltip': {
            whiteSpace: 'normal',
        },
        '& .ql-container': {
            height: 200,
            backgroundColor: '#F4F5F9',
        },
    },
    hiddenVis: {
        visibility: 'hidden',
    },
    addFile: {
        padding: 0,
        marginLeft: 'auto',
        marginRight: 25,
    },
    smallSpinner: {
        size: 24,
    },
});
const toolbarOptions = [
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }, { align: [] }],
    ['link'],
];
const modules = {
    toolbar: {
        container: toolbarOptions,
    },
    clipboard: {
        // Fixes a bug where lots of empty Ps are inserted
        // https://github.com/quilljs/quill/issues/1379
        matchVisual: false,
    },
};
function SendMailActionPicker(props) {
    const { action, onChangeAction, event, disabled = false } = props;
    const config = action === null || action === void 0 ? void 0 : action.workflowActionConfig;
    let subject = 'issue';
    switch (event) {
        case lib_event_1.default.OP_MISSED:
        case lib_event_1.default.OP_DUE:
        case lib_event_1.default.OP_COMPLETE:
        case lib_event_1.default.OP_LATE:
            subject = 'op';
            break;
        case lib_event_1.default.SENSOR_READING:
        case lib_event_1.default.SCHEDULE:
            subject = 'asset';
            break;
    }
    const canAttachReport = [lib_event_1.default.OP_COMPLETE, lib_event_1.default.ISSUE_ASSIGNED, lib_event_1.default.ISSUE_CLOSED, lib_event_1.default.ISSUE_COMMENT,
        lib_event_1.default.ISSUE_CREATED, lib_event_1.default.ISSUE_MISSED, lib_event_1.default.ISSUE_STATUS_CHANGED].includes(event);
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const [html, setHtml] = (0, react_1.useState)((config === null || config === void 0 ? void 0 : config.body) || '');
    const handleChangeSendTo = (0, react_1.useCallback)(emails => {
        config.sendTo = emails; //.push(email)
        action.workflowActionConfig = config;
        onChangeAction(new WorkflowAction_1.default(action));
    }, [config, action, onChangeAction]);
    const handleChangeIncludeSubjectDetails = (0, react_1.useCallback)(() => {
        if (config.includeSubjectDetails) {
            config.includeSubjectDetails = false;
            config.includeReportLink = false;
            config.includePDF = false;
        }
        else {
            config.includeSubjectDetails = true;
        }
        action.workflowActionConfig = config;
        onChangeAction(new WorkflowAction_1.default(action));
    }, [config, action, onChangeAction, event]);
    const handleChangeIncludeType = (0, react_1.useCallback)((value) => {
        if (value === 'includePDF') {
            config.includePDF = true;
            config.includeReportLink = false;
        }
        else {
            config.includeReportLink = true;
            config.includePDF = false;
        }
        action.workflowActionConfig = config;
        onChangeAction(new WorkflowAction_1.default(action));
    }, [config, action, onChangeAction, event]);
    return (react_1.default.createElement(Vertical_1.default, { gutter: true },
        react_1.default.createElement(Horizontal_1.default, { centered: true, gutter: true, justify: 'flex-start' },
            react_1.default.createElement(Text_1.default, { style: { minWidth: 100 } }, lib_i18n_1.default.t('sendto')),
            react_1.default.createElement(TextFieldWithEmails_1.default, { fullWidth: true, placeholder: lib_i18n_1.default.t('enter-email-addresses'), disabled: disabled, value: config === null || config === void 0 ? void 0 : config.sendTo, onChange: handleChangeSendTo })),
        react_1.default.createElement(Horizontal_1.default, { centered: true, gutter: true, justify: 'flex-start' },
            react_1.default.createElement(Text_1.default, { style: { minWidth: 100 } }, lib_i18n_1.default.t('subject')),
            react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { disabled: disabled, fullWidth: true, value: (config === null || config === void 0 ? void 0 : config.subject) || '', onBlur: t => {
                    config.subject = t;
                    action.workflowActionConfig = config;
                    onChangeAction(new WorkflowAction_1.default(action));
                } })),
        react_1.default.createElement(Horizontal_1.default, { centered: true, gutter: true, justify: 'flex-start' },
            react_1.default.createElement(Text_1.default, { style: { minWidth: 100 } }, lib_i18n_1.default.t('body')),
            react_1.default.createElement("div", { onBlur: () => {
                    config.body = html;
                    action.workflowActionConfig = config;
                    onChangeAction(new WorkflowAction_1.default(action));
                }, style: { width: '100%' } },
                react_1.default.createElement(react_simple_quill_1.default, { disabled: disabled, className: myCss.root, modules: modules, value: html, onChange: (content, delta, source, quill) => {
                        setHtml(quill.getHTML());
                    } }))),
        react_1.default.createElement(Checkbox_1.default, { label: (0, react_markdown_1.markdown)(lib_i18n_1.default.t('include-subject-details', {
                subject,
            })), disabled: disabled, color: lib_palette_1.default.secondary, checked: !!(config === null || config === void 0 ? void 0 : config.includeSubjectDetails), onChange: handleChangeIncludeSubjectDetails }),
        canAttachReport && !!(config === null || config === void 0 ? void 0 : config.includeSubjectDetails) && (react_1.default.createElement("div", { style: { marginLeft: 20 } },
            react_1.default.createElement(RadioGroup_1.default, { value: !!(config === null || config === void 0 ? void 0 : config.includePDF) ? 'includePDF' : 'includeReportLink', onChange: handleChangeIncludeType },
                react_1.default.createElement(Vertical_1.default, null,
                    react_1.default.createElement(Horizontal_1.default, { justify: "flex-start", gutter: true, centered: true },
                        react_1.default.createElement(Radio_1.default, { value: "includePDF", checked: !!(config === null || config === void 0 ? void 0 : config.includePDF) }),
                        react_1.default.createElement(Text_1.default, { color: !!(config === null || config === void 0 ? void 0 : config.includePDF) ? undefined : 'lightgrey' }, (0, react_markdown_1.markdown)(lib_i18n_1.default.t('attach-subject-pdf', {
                            subject,
                        })))),
                    react_1.default.createElement(Horizontal_1.default, { justify: "flex-start", gutter: true, centered: true },
                        react_1.default.createElement(Radio_1.default, { value: "includeReportLink", checked: !!(config === null || config === void 0 ? void 0 : config.includeReportLink) }),
                        react_1.default.createElement(Text_1.default, { color: !!(config === null || config === void 0 ? void 0 : config.includeReportLink) ? undefined : 'lightgrey' }, (0, react_markdown_1.markdown)(lib_i18n_1.default.t('link-subject-report', {
                            subject,
                        }))))))))));
}
exports.SendMailActionPicker = SendMailActionPicker;
exports.default = SendMailActionPicker;
